import styled from 'styled-components';
import { RalewayFont } from 'constants/fonts';

export const FinalStepWrapper = styled.div`
  text-align: left;
  position: relative;
  padding-top: 3rem;
  padding-bottom: 3rem;
  width: 80rem;
  max-width: 90%;
  margin: 0 auto;

  > .images {
    text-align: center;
    .bg_completed_narrative {
      width: 31rem;
    }

    .img_completed_narrative {
      width: 22rem;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 8rem;
    }
  }

  > .title {
    color: #fff;
    font-size: 1.9rem;
    line-height: 2rem;
    font-family: ${RalewayFont.regularFamily};
    margin-top: -6rem;

    > b {
      color: #fff;
    }
  }

  > .ongoing_title {
    color: #fff;
    font-size: 1.9rem;
    line-height: 2rem;
    font-family: ${RalewayFont.regularFamily};
    margin-top: 10rem;
    margin-bottom: 2rem;

    > b {
      color: #fff;
    }
  }

  .buttons {
    margin-top: 2rem;
    text-align: center;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Steps/FinalStep/components/styles.js